import DataTableIniter from './views/components/dataTablesIniter.js';
let instance = null;

/**
 * This class is a sinpleton which is responsible to deal with view's lifecycle
 */
class ViewRegistry {
  constructor() {
    if (!instance) {
      instance = this;
    } // eslint-disable-line consistent-this
    this.currentView = null;
    this.currentViewSource = null;
    return instance;
  }

  initializeCommonComponents() {
    if (this.ioTable !== undefined) {
      this.ioTable.destroy();
      delete this.ioTable;
    }

    if ($('.io-table').length > 0 && !_.isFunction(this.currentViewSource)) {
      this.ioTable = new DataTableIniter();
    }
  }

  setPageTitle() {
    let pageTitle = $('h2');

    if (pageTitle.length) {
      document.title = pageTitle[0].outerText;
    }
  }

  load(View, ...args) {
    // Destroys the previous view
    if (this.currentView) {
      if (_.isFunction(this.currentView._destroy)) {
        this.currentView._destroy();
      } else if (_.isFunction(this.currentView.destroy)) {
        this.currentView.destroy();
      }
      this.currentView = null;
      this.currentViewSource = null;
    }

    // Loads the new view
    if (_.isFunction(View)) {
      this.currentViewSource = View;
      this.currentView = new View(...args);
    }
    this.initializeCommonComponents();
    this.setPageTitle();
  }

  getError(status) {
    if (
      _.has(this.currentView, 'errors') &&
      _.has(this.currentView.errors, status)
    ) {
      return this.currentView.errors[status];
    }
    return false;
  }

  error() {
    if (this.currentView) {
      this.currentView.error();
    }
  }
}

module.exports = new ViewRegistry();
